import axios from "axios";
import { BASE_URL } from "../utils/constants";
import { logErrorToServer } from "./logs";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token from localStorage to all requests
api.interceptors.request.use((config) => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('access_token') : null;
  if (token) {
    config.headers = config.headers || {};
    (config.headers as any).Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 1. Handle 401 Unauthorized globally
    if (error?.response?.status === 401) {
      if (typeof window !== "undefined") {
        localStorage.removeItem("access_token");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    } else {
      // 2. Log other errors to the server (Network errors, 5xx, etc.)
      logErrorToServer(error);
    }

    return Promise.reject(error);
  }
);

export default api;
